<template>
  <div class="container">
    <Nav></Nav>
    <div class="banner"></div>
    <div class="bread">
      <div>
        <div class="bread-mulu">
          <img
            src="../assets/images/newlist-mulu.png"
            alt=""
            @click="$router.push({ path: '/' })"
            style="cursor:pointer"
          />
          <span></span>
          <p
            @click="$router.push({ path: '/newscenter' })"
            style="cursor:pointer"
          >
            新闻中心
          </p>
          <span></span>
          <p v-if="list.length > 0">{{ list[1].IndustryTypeName }}</p>
          <span></span>
          <p class="br-name">文章详情</p>
        </div>
      </div>
    </div>
    <div class="con">
      <div class="content">
        <div class="left">
          <div class="con-left">
            <div class="time">
              <div>{{ newsData }}</div>
              <div>{{ newsMouth }}</div>
            </div>
            <!-- <p class="share">— 分享 —</p>
                        <div class="share-spc">
                            <img src="../assets/images/newsdetail-weibo.png" alt="">
                            <img src="../assets/images/newsdetail-wechat.png" alt="">
                            <img src="../assets/images/newsdetail-qq.png" alt="">
                        </div> -->
          </div>
          <div class="con-right" v-if="list.length > 0">
            <p class="title">{{ list[1].Title }}</p>
            <hr />
            <div class="coon" v-html="list[1].Content"></div>
          </div>
        </div>
        <div class="right" v-if="list.length > 0">
          <div class="con-right" v-if="list.length > 0">
            <div
              class="con-pre"
              @click="toPre(list[0].Id)"
              v-if="list[0].Content"
            >
              <p class="pre">上一篇</p>
              <p class="title">{{ list[0].Title }}</p>
              <!-- <p class="title">周，全球领先的人工智能平台公司商汤科技与中国物业管理行业践行者蓝光嘉宝服务在成都举行“商汤-嘉宝联合实验室揭牌仪式你开局考试需看到了·你看了哪里能看看·看看哪款你看辽宁科技老奶奶和你还可能仅仅两款i111笔记本不合格还不够好VGuu1不会尽快</p> -->
            </div>
            <hr v-if="list[0].Content && list[2].Content" />
            <div
              class="con-next"
              @click="toNext(list[2].Id)"
              v-if="list[2].Content"
            >
              <p class="next">下一篇</p>
              <p class="title" v-if="list[2]">{{ list[2].Title }}</p>
              <!-- <p class="title">周，全球领先的人工智能平台公司商汤科技与中国物业管理行业践行者蓝光嘉宝服务在成都举行“商汤-嘉宝联合实验室揭牌仪式你开局考试需看到了·你看了哪里能看看·看看哪款你看辽宁科技老奶奶和你还可能仅仅两款i111笔记本不合格还不够好VGuu1不会尽快</p> -->
            </div>
          </div>
          <!-- <div class="lian">
                        <img src="../assets/images/banner-box.png" alt="">
                    </div> -->
          <div class="con-bottom" v-if="list[1].GzhUrl">
            <p class="tui">相关文章公众号推荐</p>
            <img :src="list[1].GzhUrl" alt="" />
            <p class="huo">— 获取更多精彩资讯 —</p>
            <p class="guan">关注公众号<span></span></p>
          </div>
          <div class="con-bottom" v-if="list[1].XcxUrl">
            <p class="tui">相关文章小程序推荐</p>
            <img :src="list[1].XcxUrl" alt="" />
            <p class="huo">— 获取更多精彩资讯 —</p>
            <p class="guan">使用小程序<span></span></p>
          </div>
          <div class="con-bottom" v-if="list[1].AppUrl">
            <p class="tui">相关文章APP推荐</p>
            <img :src="list[1].AppUrl" alt="" />
            <p class="huo">— 获取更多精彩资讯 —</p>
            <p class="guan">下载APP<span></span></p>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Nav from "@/components/topNav.vue";
import Footer from "@/components/footer.vue";
export default {
  components: {
    Nav,
    Footer
  },
  data() {
    return {
      id: 6, // 新闻id
      list: [], // 新闻列表
      newsTime: "", // 新闻时间
      newsMouth: "", // 新闻月份
      newsData: "" // 新闻日期
    };
  },
  mounted() {
    // console.log(this.$route.query, 'query')
    let id = this.$route.query.id;
    this.id = this.$route.query.id;
    this.getDetail();
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    window.pageYOffset = 0;
  },
  watch: {
    id(newValue) {
      let query = this.$router.history.current.query;
      let path = this.$router.history.current.path;
      // 对象的拷贝
      let newQuery = JSON.parse(JSON.stringify(query));
      // 地址栏的参数值赋值
      newQuery.id = newValue;
      this.$router.push({ path, query: newQuery });
    }
  },
  methods: {
    async getDetail() {
      //   console.log(this.id, 'iddddd')
      let that = this;
      await this.axios({
        method: "GET",
        url: "/api/news/GetNewDetail",
        params: {
          id: that.id
        }
      })
        .then(result => {
          //   console.log(result, 'result')
          that.list = result.data.data;
          that.time = that.list[1].AddDateTime;
          that.chaneTime();
        })
        .catch(err => {
          console.log(err);
        });
      //   console.log(this.list, 'llllll')
    },
    toNext(id) {
      //   console.log(id, 'iddd')
      this.id = id;
      this.getDetail();
      document.body.scrollTop = 0;
      // firefox
      document.documentElement.scrollTop = 0;
      // safari
      window.pageYOffset = 0;
    },
    toPre(id) {
      this.id = id;
      this.getDetail();
      document.body.scrollTop = 0;
      // firefox
      document.documentElement.scrollTop = 0;
      // safari
      window.pageYOffset = 0;
    },
    chaneTime() {
      //   console.log(this.time, 'timetime')
      //   console.log(new Date(this.time).getFullYear(), 'ppp')
      let data = new Date(this.time).getDate();
      let month = new Date(this.time).getMonth() + 1;
      let year = new Date(this.time).getFullYear();
      this.newsMouth = year + "." + month;
      this.newsData = data;
    }
  }
};
</script>

<style scoped>
.container {
  background-color: #f7f7f7;
}
.banner {
  width: 100%;
  height: 300px;
  background: url("../assets/images/newslist-banner.png") no-repeat center;
  overflow: hidden;
}
.bread {
  width: 100%;
  height: 56px;
  background: #fbfbfb;
}
.bread div {
  width: 1200px;
  margin: 0px auto;
}
.bread .bread-mulu {
  width: 280px;
  float: left;
  line-height: 56px;
  display: flex;
  justify-content: space-between;
}
.bread .bread-mulu img {
  width: 12px;
  height: 12px;
  align-self: center;
  vertical-align: 0px;
}
.bread .bread-mulu span {
  display: inline;
  width: 0px; /*  宽高设置为0，很重要，否则达不到效果 */
  height: 0px;
  border: 5px solid #727272;
  border-top-color: transparent; /*设置透明背景色*/
  border-right-color: transparent;
  border-bottom-color: transparent;
  align-self: center;
  margin-right: -15px;
}
.bread .bread-mulu .br-name {
  color: #b00000;
}
.con .content {
  /* height: 800px; */
  width: 1300px;
  /* background-color: orange; */
  margin: 25px auto 80px;
  display: flex;
  justify-content: space-between;
}
.con .content .left {
  width: 1040px;
  /* height: 800px; */
  background-color: #fff;
}
.con .content .right {
  width: 240px;
  /* height: 800px; */
  /* background-color: pink; */
}
.con .content .left {
  padding: 0px 24px;
  display: flex;
  justify-content: space-between;
}
.content .left .con-left {
  width: 100px;
  /* height: 800px; */
  /* background-color: orange; */
}
.content .left .con-right {
  width: 860px;
  /* height: 800px; */
  /* background-color: orange; */
  text-align: center;
}
.content .left .con-left .time div:first-child {
  height: 75px;
  background: #ededed;
  margin-top: 30px;
  font-size: 46px;
  font-family: Arial;
  font-weight: bold;
  color: #b00000;
  text-align: center;
  line-height: 75px;
}
.content .left .con-left .time div:nth-child(2) {
  height: 32px;
  background: #b00000;
  font-size: 16px;
  font-family: Arial;
  font-weight: bold;
  color: #ffffff;
  line-height: 32px;
  text-align: center;
}
.content .left .con-left .share {
  margin: 20px auto;
  text-align: center;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #999999;
}
.content .left .con-left .share-spc {
  text-align: center;
}
.content .left .con-left .share-spc img {
  display: block;
  margin: 18px auto 0px;
}
.content .left .con-right .title {
  font-size: 26px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  margin: 24px auto 10px;
  text-align: center;
}
.content .left .con-right hr {
  border: none;
  border-top: 1px solid #e2e2e2;
}
.content .left .con-right .coon {
  width: 840px;
  text-align: left;
  margin: 20px auto 0px;
  line-height: 30px;
  font-size: 16px;
  color: #333;
  letter-spacing: 1px;
}
.content .right .con-right {
  width: 240px;
  /* height: 195px; */
  background-color: #fff;
  box-shadow: 2px 2px 7px 0px rgba(98, 98, 98, 0.1);
}
.content .right .con-right .con-pre {
  overflow: hidden;
  width: 220px;
  height: 100px;
  /* background-color: orange; */
  margin: 0px auto;
}
.content .right .con-right .con-next {
  overflow: hidden;
  width: 220px;
  height: 100px;
  /* background-color: orange; */
  margin: 0px auto;
}
.content .right .con-right .con-pre .pre {
  margin-top: 10px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  font-size: 14px;
}
.content .right .con-right .con-pre .title {
  font-family: PingFang SC;
  font-weight: 500;
  color: #666666;
  line-height: 26px;
  height: 46px;
  overflow: hidden;
  /* background-color: #fff; */
  margin-top: 8px;
  cursor: pointer;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.content .right .con-right .con-next .next {
  margin-top: 8px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  font-size: 14px;
}
.content .right .con-right .con-next .title {
  font-family: PingFang SC;
  font-weight: 500;
  color: #666666;
  line-height: 26px;
  height: 46px;
  overflow: hidden;
  /* background-color: #fff; */
  margin-top: 8px;
  cursor: pointer;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.content .right .con-right hr {
  width: 220px;
  border: none;
  border-top: 1px solid #e2e2e2;
  /* margin-top: 13px; */
  margin: 13px auto 0px;
}
/* .content .right .lian{
    width:240px;
    height: 60px;
    background-color: #fff;
    margin-top: 50px;
}
.content .right .lian img{
    width: 240px;
    height: 60px;
} */
.content .right .con-bottom {
  margin-top: 20px;
  width: 240px;
  height: 240px;
  background-color: #fff;
  text-align: center;
  box-shadow: 2px 2px 7px 0px rgba(98, 98, 98, 0.1);
  overflow: hidden;
}
.content .right .con-bottom:first-child {
  margin-top: 250px;
}
.content .right .con-bottom .tui {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  margin-top: 16px;
}
.content .right .con-bottom img {
  margin-top: 13px;
  width: 112px;
}
.content .right .con-bottom .huo {
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
  margin-top: 5px;
}
.content .right .con-bottom .guan {
  position: relative;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
  margin-top: 5px;
}
.content .right .con-bottom .guan span {
  display: inline-block;
  position: absolute;
  left: 86px;
  top: 8px;
  width: 68px;
  height: 10px;
  background: #b00000;
  opacity: 0.1;
}
.con-right .coon img {
  max-width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/views/newsDetail.vue